import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Home1 from "../Images/Home1.jpg";
import Home2 from "../Images/Home2.jpg";
import Home3 from "../Images/Home3.jpg";
import Home4 from "../Images/Home4.jpg";
import Home5 from "../Images/Home5.jpg";
import Home6 from "../Images/Home6.jpg";

const images = [Home1, Home2, Home3, Home4, Home5, Home6];

const HeroSlider = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="
        pt-4 w-full overflow-hidden relative
        h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px]
      "
    >
      <AnimatePresence>
        <motion.img
          key={current}
          src={images[current]}
          alt={`Slide ${current}`}
          className="w-full h-full object-cover absolute top-0 left-0"
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{
            duration: 1.5,
            ease: [0.43, 0.13, 0.23, 0.96],
          }}
        />
      </AnimatePresence>
    </div>
  );
};

export default HeroSlider;
